<div class="filter-controls">
  <button type="button" class="filter-trigger" [attr.aria-expanded]="isOpen" (click)="open()" aria-label="Open analytics filters">
    <span aria-hidden="true">&#9776;</span> Filter
  </button>
  <button *ngIf="hasAppliedFilters" type="button" class="clear-active-filter" (click)="clear()">Clear Filters</button>
</div>

<div class="filter-backdrop" *ngIf="isOpen" (click)="isOpen = false">
  <section class="filter-dialog" role="dialog" aria-modal="true" aria-label="Analytics filters" (click)="$event.stopPropagation()">
    <button type="button" class="filter-close" aria-label="Close filters" (click)="isOpen = false">&times;</button>
    <h2>Filter</h2>
    <div class="filter-fields">
      <div class="filter-field">
        <label class="filter-label" [for]="idPrefix + '-group-by'">Group By
          <i class="info-tip" tabindex="0" aria-label="Choose how to group the data." data-tooltip="Show data by Department, Business or Company.">i</i>
        </label>
        <select [id]="idPrefix + '-group-by'" [(ngModel)]="draftGroupBy">
          <option value="department">Department</option>
          <option value="business">Business</option>
          <option value="company">Company</option>
        </select>
      </div>
      <div class="filter-field">
        <label class="filter-label" [for]="idPrefix + '-employment-type'">Employee Type
          <i class="info-tip" tabindex="0" aria-label="Choose which employees to include." [attr.data-tooltip]="onRollOnly ? 'Expenses include On-Roll employees only.' : 'Show All Employees, On-Roll only or Off-Roll only.'">i</i>
        </label>
        <select [id]="idPrefix + '-employment-type'" [(ngModel)]="draftEmploymentType" [disabled]="onRollOnly">
          <option *ngIf="!onRollOnly" value="">All Employees</option>
          <option value="On-Roll">On-Roll</option>
          <option *ngIf="!onRollOnly" value="Off-Roll">Off-Roll</option>
        </select>
      </div>
      <div class="filter-field date-field">
        <label class="filter-label" [for]="idPrefix + '-from'">From Date
          <i class="info-tip" tabindex="0" aria-label="Choose the start date." data-tooltip="Data starts from this month.">i</i>
        </label>
        <input [id]="idPrefix + '-from'" type="date" [value]="draftStartDate" [max]="draftEndDate || maxDate"
               (change)="onStartDate($any($event.target).value)" />
      </div>
      <div class="filter-field date-field">
        <label class="filter-label" [for]="idPrefix + '-to'">To Date
          <i class="info-tip" tabindex="0" aria-label="Choose the end date." data-tooltip="Data ends in this month. Future months cannot be selected.">i</i>
        </label>
        <input [id]="idPrefix + '-to'" type="date" [value]="draftEndDate" [min]="draftStartDate" [max]="maxDate"
               (change)="draftEndDate = $any($event.target).value" />
      </div>
    </div>
    <div class="filter-actions">
      <button type="button" class="clear-button" (click)="clear()">Remove All Filters</button>
      <button type="button" class="apply-button" [disabled]="invalidRange" (click)="apply()">Apply</button>
    </div>
  </section>
</div>
